import React, { useEffect } from 'react';
import Icon from 'components/AppIcon';

const SuccessToast = ({ isVisible, onClose, message }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(onClose, 3500);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-20 lg:bottom-6 left-1/2 -translate-x-1/2 z-[300] flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl"
      style={{ backgroundColor: '#059669', color: '#fff', minWidth: '280px', maxWidth: '90vw' }}
      role="alert"
      aria-live="polite"
    >
      <Icon name="CheckCircle" size={20} color="#fff" />
      <span className="font-caption font-semibold text-sm flex-1">{message}</span>
      <button onClick={onClose} className="ml-2 opacity-80 hover:opacity-100" aria-label="Dismiss">
        <Icon name="X" size={16} color="#fff" />
      </button>
    </div>
  );
};

export default SuccessToast;